module.exports = {
	inviteCode: "Invitattion Code",
	changeAvatar: "Click",
	company: "Company",
	address: "Address",
	newPassword: "New Password"
}


// WEBPACK FOOTER //
// ./src/pages/detail/i18n/locale.en.js